/* eslint-disable import/no-duplicates */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unescaped-entities */
import React, {
  useContext, useEffect, useState,
} from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import MenuArrowSVG from '../icons/menu-arrow.svg';
import Spinner from '../../shared/spinner';
import { HeaderContext } from '../../../contexts/headerContext';

import useMenu from '../../../hooks/useMenu';
import { trackEvent } from '../../../utils/analytics';
import EventNames from '../../../utils/event-name-constants';
import { useFirebase } from '../../../contexts/ssr-firebase-context';
import { useUser } from '../../../contexts/ssr-user-context';

const nIASlegaCyRedirectList = ['/student'];

function LeftSidebar() {
  const router = useRouter();
  const { user } = useUser();
  const [activeRoute, setActiveRoute] = useState(router.pathname);
  const { getConfigValue } = useFirebase();
  const webHomeMenus = getConfigValue('webHomeMenus');
  const { setShowLogoutPopup } = useContext(HeaderContext);
  const localMenus = useMenu(user);
  const { HOME_TAB_OPENED } = EventNames;
  let visibleMenus;
  if (webHomeMenus?.leftSidebarMenu) {
    visibleMenus = localMenus
      .map((localItem) => {
        const remoteItem = webHomeMenus.leftSidebarMenu.find((remote) => remote.label === localItem.label);
        return remoteItem ? { ...remoteItem, icon: localItem.icon, iconFill: localItem.iconFill } : null;
      })
      .filter(Boolean); // Remove null values if any
  }

  const handleNavigate = (route, label, legacyPage) => {
    if (label === 'Logout') {
      setShowLogoutPopup(true);
    } else if (nIASlegaCyRedirectList.some((prefix) => route.startsWith(prefix)) || legacyPage === true) {
      const host = window.location.origin;
      const url = `${host}${route}`;
      window.open(url);
    } else {
      if (label === 'Home') {
        trackEvent(HOME_TAB_OPENED, {
          tabName: 'Home',
        });
      }
      router.push(route);
    }
  };

  return (
    <div className="w-100 h-screen bg-white shadow-md">
      {/* <div className="p-4 text-center font-bold text-lg text-white pt-10">
        <Image
          width={500}
          height={500}
          src={logo}
          alt="NextIas Easy Logo"
          className="w-[128px] h-6 lg:w-[175px] lg:h-8 m-auto"
        />
      </div> */}
      <ul>
        {visibleMenus?.map((item, index) => (
          <li
            key={item?.route}
            onClick={() => {
              handleNavigate(item?.route, localMenus[index]?.label, item?.isLegacyPage);
              setActiveRoute(item?.route);
            }}
            className={`flex items-center px-4 py-3 cursor-pointer ${
              (activeRoute === item.route)
                ? 'bg-lightThinBlue text-customBlue'
                : 'text-grayLight hover:bg-lightThinBlue hover:text-customBlue'
            }`}
          >
            <Image
              className="material-icons text-grayLight"
              src={
                  activeRoute === item.route
                    ? visibleMenus[index]?.iconFill
                    : visibleMenus[index]?.icon
                }
              width={24}
              height={24}
              alt={`${item.label} Icon`}
            />
            <span
              className={`ml-4 flex-grow ${
                activeRoute === item.route
                  ? 'text-customBlue'
                  : 'text-grayLight'
              }`}
            >
              {item.label}
            </span>
            <span className="text-grayLight">
              <Image width={16} height={16} src={MenuArrowSVG} alt="Menu Arrow" />
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default LeftSidebar;
